import type { BeneficialOwnerData } from '@gcv/shared';

export const mapOwnerToBeneficialOwnerData = (owner: BeneficialOwnerData): BeneficialOwnerData => ({
  beneficial_owner_first_name: owner.beneficial_owner_first_name,
  middle_initial: owner.middle_initial,
  beneficial_owner_last_name: owner.beneficial_owner_last_name,
  job_title_occupation: owner.job_title_occupation,
  date_of_birth: owner.date_of_birth,
  street_address: owner.street_address,
  city: owner.city,
  state: owner.state,
  zip_code: owner.zip_code,
  country: owner.country,
  us_person: owner.us_person,
  identification_id: owner.identification_id,
  country_of_issuance: owner.country_of_issuance,
  identification_doument_ids: owner.identification_doument_ids,
  ownership_in_this_business: owner.ownership_in_this_business
});
